import { clone, debounce, each, filter, find, includes, remove } from 'lodash'

export default {
  props: {
    value: {
      type: [Boolean, Number, String, Object, Array],
      default: null
    },

    multiple: {
      type: Boolean,
      default: false
    },

    visible: {
      type: Boolean,
      default: true
    },

    search: {
      type: Boolean,
      default: false
    },

    searchDebounce: {
      type: Number,
      default: 500
    }
  },

  watch: {
    value: 'valueUpdated',

    search: 'searchUpdated',

    searchValue: function () {
      if (this.searchValue === '') {
        this.searchUpdated()
      } else {
        debounce(this.searchUpdated, this.searchDebounce)()
      }
    },

    visible: 'setFocus'
  },

  data () {
    return {
      registeredOptions: [],
      searchValue: '',
      preventBlur: false
    }
  },

  mounted () {
    this.setFocus()
  },

  computed: {
    amountOfOptionsVisible () {
      return filter(this.registeredOptions,
        registeredOption => registeredOption.visible)
        .length
    }
  },

  methods: {
    registerOption (option) {
      this.registeredOptions.push(option)

      option.instance.valueUpdated(this.getSanitizedValue())
    },

    unregisterOption (option) {
      remove(this.registeredOptions,
          registeredOption => registeredOption.instance === option.instance)
    },

    updateOption (option) {
      const foundOption = find(this.registeredOptions,
        registeredOption => registeredOption.instance === option.instance)

      foundOption.value = option.value
      foundOption.visible = option.visible

      // We call this function to let the updated option know what the currently selected values are
      option.instance.valueUpdated(this.getSanitizedValue())
    },

    optionClicked (option) {
      let values = clone(this.value)

      if (this.multiple) {
        if (includes(this.value, option.value)) {
          remove(values, selectedValue => selectedValue === option.value)
        } else {
          values = [option.value, ...this.value]
        }
      } else {
        values = option.value
      }

      this.$emit('input', values)
    },

    valueUpdated () {
      each(this.registeredOptions, option => {
        option.instance.valueUpdated(this.getSanitizedValue())
      })
    },

    getSanitizedValue () {
      return this.multiple ? this.value : [this.value]
    },

    searchUpdated () {
      each(this.registeredOptions, option => {
        option.instance.searchUpdated(this.search ? this.searchValue : '')
      })
    },

    focusIn () {
      this.preventBlur = true
    },

    focusOut () {
      const self = this

      this.preventBlur = false

      // We use setTimeout instead of Vue.$nextTick because we need to set a macro-event (task) instead of a micro-event (job).
      setTimeout(() => {
        if (!self.preventBlur) {
          self.$emit('blur')
        }
      })
    },

    setFocus () {
      const self = this

      this.$nextTick(() => {
        if (self.visible) {
          self.$refs.dropdown.focus()
        }

        self.searchValue = ''
      })
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/pro4all-ui/ui-kit/mixins/Dropdown.js
// module id = TF9l
// module chunks = 0